<template>
   <div class="tabulation">
      <el-card class="chart-card">
         <div class="grabble" @keyup.enter="searchBtn">
            <el-input class="hunt" v-model="memberName" placeholder="请输入会员姓名" size="large" clearable />
            <el-input class="hunt" v-model="memberCode" placeholder="请输入会员编码" size="large" clearable />
            <el-select class="hunt" v-model="unionName" placeholder="请选择组织名称" size="large" clearable @click="multiple"
               @focus="closeIt" @clear="clearUnion" ref="selectIt" />
            <el-select class="hunt" v-model="productCode" placeholder="请选择保障产品名称" size="large" clearable>
               <el-option v-for="item in productOptions" :key="item.productCode" :label="item.productName"
                  :value="item.productCode" style="width:100%; text-align-last: center;" />
            </el-select>
            <el-date-picker class="date-hunt" v-model="insuranceDateRange" type="daterange" range-separator="至"
               start-placeholder="请选择投保开始日期" end-placeholder="请选择投保结束日期" size="large" @change="handleDateChange"
               style="margin-right: 10px;" />
            <el-input class="hunt" v-model="periodYear" placeholder="请输入保障年度（例：2026）" size="large" clearable />
            <el-button style="margin-left: 10px" type="primary" size="large" @click="searchBtn" :loading="formative">
               <el-icon class="cancelgu">
                  <Search />
               </el-icon>搜索
            </el-button>
         </div>

         <div class="hint">统计 : {{ altogether }}条</div>

         <div class="feature-btn">
            <el-button style="margin-left: 10px" type="primary" size="default" @click="goSafeguardTime">
               <el-icon class="cancelgu">
                  <Setting />
               </el-icon>保障期管理
            </el-button>
            <el-button style="margin-left: 10px" type="primary" size="default" @click="goSafeguardProduct">
               <el-icon class="cancelgu">
                  <Setting />
               </el-icon>保障产品管理
            </el-button>
            <el-button style="margin-left: 10px" type="primary" size="default" @click="refundProduct">
               <el-icon class="cancelgu">
                  <Setting />
               </el-icon>退款管理
            </el-button>
            <el-button style="margin-left: 10px" type="primary" size="default" @click="payout">
               <el-icon class="cancelgu">
                  <Download />
               </el-icon>导出
            </el-button>

         </div>

         <el-table ref="tableRef" v-loading="listLoading" :data="filterTableData" style="width: 100%" row-key="id"
            border scrollbar-always-on :header-cell-style="{ background: '#F5F7FA' }" :empty-text="texts">
            <el-table-column fixed align="center" label="会员姓名" prop="name" min-width="130"
               :show-overflow-tooltip="true" />
            <el-table-column label="会员编码" prop="username" align="center" min-width="150"
               :show-overflow-tooltip="true" />
            <el-table-column label="手机号" prop="mobile" align="center" min-width="140" :show-overflow-tooltip="true">
               <template #default="scope">
                  {{ emptyText(scope.row.mobile) }}
               </template>
            </el-table-column>
            <el-table-column label="所属工会" prop="unionName" align="center" min-width="160" :show-overflow-tooltip="true">
               <template #default="scope">
                  {{ emptyText(scope.row.unionName) }}
               </template>
            </el-table-column>
            <el-table-column label="所属部门" prop="departmentName" align="center" min-width="200"
               :show-overflow-tooltip="true">
               <template #default="scope">
                  {{ emptyText(scope.row.departmentName) }}
               </template>
            </el-table-column>
            <el-table-column label="保障产品名称" align="center" min-width="250" :show-overflow-tooltip="true">
               <template #default="scope">
                  {{ formatProductNames(scope.row.itemList) }}
               </template>
            </el-table-column>
            <el-table-column label="保障年度" prop="periodYear" align="center" min-width="120" />
            <el-table-column label="订单编号" prop="orderNumber" align="center" min-width="250"
               :show-overflow-tooltip="true" />
            <el-table-column label="年度费用" prop="annualFeeAmount" align="center" min-width="120" />
            <el-table-column label="工会补贴" prop="unionSubsidyAmount" align="center" min-width="120" />
            <el-table-column label="会员缴费" prop="memberPayAmount" align="center" min-width="120" />
            <el-table-column label="订单退款金额" prop="refundAmount" align="center" min-width="140">
               <template #default="scope">
                  {{ emptyText(scope.row.refundAmount) }}
               </template>
            </el-table-column>
            <el-table-column label="订单当前有效金额" prop="actualMemberPayAmount" align="center" min-width="160">
               <template #default="scope">
                  {{ emptyText(scope.row.actualMemberPayAmount) }}
               </template>
            </el-table-column>
            <el-table-column label="退款状态" align="center" min-width="120">
               <template #default="scope">
                  {{ formatRefundState(scope.row.refundState) }}
               </template>
            </el-table-column>
            <el-table-column label="支付状态" align="center" min-width="120">
               <template #default="scope">
                  {{ formatPayState(scope.row.payState) }}
               </template>
            </el-table-column>
            <el-table-column label="投保时间" align="center" min-width="170" :show-overflow-tooltip="true">
               <template #default="scope">
                  {{ formatTime(scope.row.payTime) }}
               </template>
            </el-table-column>
         </el-table>

         <el-pagination :hide-on-single-page="true" layout="prev, pager, next,sizes" :page-sizes="[6, 10, 15, 20]"
            v-model:currentPage="currentPage" :page-size="pagesize" :total="paginationTotal"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </el-card>

      <div>
         <el-dialog v-model="visible" title="所属组织" width="500px" top="10vh" custom-class="organization-dialog"
            :close-on-click-modal="false" destroy-on-close>
            <el-tree :data="texture" :props="defaultProps" accordion @node-click="dendrogram" />
            <template #footer><el-button type="primary" @click="confirmUnion">确定</el-button></template>
         </el-dialog>
      </div>

      <div>
         <s3-layer v-model="anew" title="提示" :shadeClose="true" :area="['50px', '170px']">
            <div class="task">
               {{ quoth }}
            </div>
         </s3-layer>
      </div>
   </div>
</template>

<script setup>
import { ref, onMounted, onActivated, nextTick } from "vue";
import { Download, Setting, EditPen, Plus, Search } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import { useRouter, onBeforeRouteLeave } from "vue-router";
import moments from "moment";
import qs from "qs";
import axios from "../../utils/requests";
import { ZClist } from "../../utils/api";

const queryOrderList = (data) => {
   return axios({
      url: "/mutualInsurance/order/queryOrderList",
      method: "post",
      data,
      config: {
         headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            timeout: 10000,
            accessToken: sessionStorage.getItem("token"),
         },
      },
   });
};

const queryProductOptions = (data) => {
   return axios({
      url: "/mutualInsurance/product/queryProductOptions",
      method: "post",
      data,
      config: {
         headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            timeout: 10000,
            accessToken: sessionStorage.getItem("token"),
         },
      },
   });
};

const exportOrderList = (data) => {
   return axios({
      url: "/mutualInsurance/order/exportOrderList",
      method: "post",
      data,
      config: {
         headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            timeout: 10000,
            accessToken: sessionStorage.getItem("token"),
         },
      },
   });
};

const router = useRouter();
const formative = ref(false);
const listLoading = ref(false);
const texts = ref("加载中");
const anew = ref(false);
const quoth = ref("");
const altogether = ref(0);
const paginationTotal = ref(0);
const filterTableData = ref([]);
const tableRef = ref(null);
const tableScrollLeft = ref(0);
const getTableScrollWrap = () => tableRef.value?.scrollBarRef?.wrapRef
   || tableRef.value?.$el?.querySelector?.('.el-scrollbar__wrap');
const saveTableScrollPosition = () => {
   const scrollWrap = getTableScrollWrap();
   if (scrollWrap) {
      tableScrollLeft.value = scrollWrap.scrollLeft;
   }
};
const restoreTableScrollPosition = () => {
   nextTick(() => {
      tableRef.value?.doLayout?.();
      window.requestAnimationFrame(() => {
         tableRef.value?.setScrollLeft?.(tableScrollLeft.value);
         window.requestAnimationFrame(() => tableRef.value?.setScrollLeft?.(tableScrollLeft.value));
      });
   });
};
const refreshTableLayout = () => nextTick(() => tableRef.value?.doLayout?.());

const memberName = ref("");
const memberCode = ref("");
const unionName = ref("");
const unionId = ref("");
const pendingUnionName = ref("");
const pendingUnionId = ref("");
const productCode = ref("");
const productOptions = ref([]);
const insuranceDateRange = ref("");
const payTimeFrom = ref("");
const payTimeTo = ref("");
const periodYear = ref("");

const currentPage = ref(1);
const pagesize = ref(10);

const selectIt = ref();
const visible = ref(false);
const texture = ref([]);
const defaultProps = {
   children: "unionDtoList",
   label: "unionName",
};

const closeIt = () => {
   if (selectIt.value) {
      selectIt.value.blur();
   }
};

const multiple = () => {
   pendingUnionName.value = unionName.value;
   pendingUnionId.value = unionId.value;
   visible.value = true;
};

const clearUnion = () => {
   unionId.value = "";
   pendingUnionName.value = "";
   pendingUnionId.value = "";
};

const dendrogram = (node) => {
   pendingUnionName.value = node.unionName;
   pendingUnionId.value = node.unionId || node.id || "";
};

const confirmUnion = () => {
   unionName.value = pendingUnionName.value;
   unionId.value = pendingUnionId.value;
   visible.value = false;
};

const handleDateChange = (e) => {
   if (e !== null) {
      const startTime = new Date(e[0]).getTime() / 1000;
      const endTime = new Date(e[1]).getTime() / 1000;
      const endDate = moments(endTime * 1000).format().substring(0, 10);
      payTimeFrom.value = startTime;
      payTimeTo.value = new Date(endDate + " 23:59:59").getTime() / 1000;
   } else {
      payTimeFrom.value = "";
      payTimeTo.value = "";
   }
};

const formatTime = (timestamp) => {
   if (typeof timestamp === "number") {
      return moments(timestamp * 1000).format("YYYY-MM-DD HH:mm:ss");
   }
   return timestamp || "-";
};

const formatProductNames = (list) => {
   if (!Array.isArray(list) || list.length === 0) {
      return "-";
   }
   return list.map((item) => item.productName).filter(Boolean).join("、") || "-";
};

const formatPayState = (payState) => {
   const stateMap = {
      1: "待支付",
      2: "已支付",
      3: "已关闭",
      4: "已退款",
   };
   return stateMap[payState] || "-";
};

const formatRefundState = (refundState) => {
   const stateMap = {
      0: "未退款",
      1: "部分退款",
      2: "全部退款",
   };
   return stateMap[refundState] || "-";
};

const emptyText = (value) => {
   return value === "" || value === null || value === undefined ? "-" : value;
};

const buildParams = () => {
   return {
      limit: pagesize.value,
      page: currentPage.value,
      name: memberName.value,
      username: memberCode.value,
      unionId: unionId.value,
      productCode: productCode.value,
      payTimeFrom: payTimeFrom.value,
      payTimeTo: payTimeTo.value,
      periodYear: periodYear.value,
   };
};

const buildExportParams = () => {
   return {
      name: memberName.value,
      username: memberCode.value,
      unionId: unionId.value,
      productCode: productCode.value,
      payTimeFrom: payTimeFrom.value,
      payTimeTo: payTimeTo.value,
      periodYear: periodYear.value,
   };
};

const list = () => {
   listLoading.value = true;
   altogether.value = 0;
   texts.value = "加载中";
   queryOrderList(qs.stringify(buildParams())).then((res) => {
      const data = res.data;
      if (data.code == 0) {
         const pageData = data.data.page || data.data;
         filterTableData.value = pageData.list || [];
         altogether.value = pageData.totalCount || pageData.total || 0;
         paginationTotal.value = altogether.value;
         texts.value = filterTableData.value.length === 0 ? "暂无数据" : "";
      } else {
         altogether.value = 0;
         texts.value = "暂无数据";
         ElMessage({
            message: data.msg,
            type: "error",
            center: true,
         });
      }
   }).catch((error) => {
      if (error?.isAuthExpired) return;
      altogether.value = 0;
      texts.value = "暂无数据";
      ElMessage({
         message: "获取互助保障订单列表失败",
         type: "error",
         center: true,
      });
   }).finally(() => {
      listLoading.value = false;
      formative.value = false;
      refreshTableLayout();
   });
};

const searchBtn = () => {
   formative.value = true;
   currentPage.value = 1;
   list();
};

const handleSizeChange = (size) => {
   pagesize.value = size;
   currentPage.value = 1;
   list();
};

const handleCurrentChange = (size) => {
   currentPage.value = size;
   list();
};

const payout = () => {
   exportOrderList(qs.stringify(buildExportParams())).then((res) => {
      if (res.data.code == 0) {
         anew.value = true;
         quoth.value = "任务已提交，请在右侧查看进度";
      } else {
         anew.value = false;
         ElMessage({
            message: res.data.msg,
            type: "error",
            center: true,
         });
      }
   }).catch((error) => {
      if (error?.isAuthExpired) return;
      ElMessage({
         message: "导出互助保障订单失败",
         type: "error",
         center: true,
      });
   });
};

const goSafeguardTime = () => {
   router.push("/safeguardTime");
};

const goSafeguardProduct = () => {
   router.push("/safeguardProduct");
};
const refundProduct = () => {
   router.push("/refundProduct");
};

const append = () => {
   ElMessage({
      message: "添加功能待接入",
      type: "info",
      center: true,
   });
};

const unit = (row) => {
   sessionStorage.setItem("mutualInsuranceOrder", JSON.stringify(row));
   ElMessage({
      message: "查看功能待接入",
      type: "info",
      center: true,
   });
};

const copyreader = (row) => {
   sessionStorage.setItem("mutualInsuranceOrder", JSON.stringify(row));
   ElMessage({
      message: "编辑功能待接入",
      type: "info",
      center: true,
   });
};

const lang = () => {
   ZClist().then((res) => {
      texture.value = res.data.data.manageUnionList || [];
   });
};

const getProductOptions = () => {
   queryProductOptions().then((res) => {
      if (res.data.code == 0) {
         productOptions.value = res.data.data || [];
      } else {
         ElMessage({
            message: res.data.msg,
            type: "error",
            center: true,
         });
      }
   });
};

onMounted(() => {
   list();
   lang();
   getProductOptions();
});

onActivated(() => {
   restoreTableScrollPosition();
});

onBeforeRouteLeave(() => {
   saveTableScrollPosition();
});
</script>

<style lang="scss" scoped>
.chart-card::-webkit-scrollbar {
   display: none;
}

.chart-card {
   height: calc(100vh - 145px);
   overflow: auto;
}

::v-deep .el-table__empty-block {
   border-bottom: 1px solid #EBEEF5 !important;
}

.hint {
   font-size: 14px;
   color: #909399;
}

.feature-btn {
   width: 100%;
   display: flex;
   justify-content: flex-end;
   margin: 15px 0;
}

.task {
   font-size: 14px;
}

::v-deep .el-table__body {
   margin-top: 0 !important;
   margin-bottom: 0 !important;
}

::v-deep .el-table__header {
   margin-top: 0 !important;
   margin-bottom: 0 !important;
}

.grabble {
   width: 100%;
   margin: 20px 0 15px 0;
   display: flex;
   align-items: center;
   flex-wrap: wrap;
   row-gap: 10px;

   .hunt {
      width: 13%;
      min-width: 150px;
      margin-right: 10px;
   }

   .date-hunt {
      width: 20%;
      min-width: 260px;
      margin-right: 10px;
   }
}

.cancelgu {
   margin-right: 6px;
   font-weight: bold;
}

.cancel {
   margin-right: 5px;
   font-weight: 400;
}

.bulur {
   color: #409eff;
   border: none;
   --el-button-bg-color: none;
   --el-button-hover-bg-color: none;
   --el-button-hover-text-color: none;
}

.bulur:hover {
   color: #a0cfff;
}

::v-deep .el-table__inner-wrapper::before {
   width: 0;
}

::v-deep .el-table .el-table__cell {
   padding-top: 15px;
   padding-bottom: 15px;
}

.el-card.is-always-shadow {
   width: 95%;
   padding-left: 20px;
   padding-right: 20px;
   padding-bottom: 20px;
}

::v-deep .el-card__body {
   padding: 0;
}

.el-pagination {
   margin-top: 10px;
}

.tabulation {
   margin-top: 10px;
   display: flex;
   justify-content: center;
   align-items: center;
   margin-bottom: 10px;
}

::v-deep .el-select-dropdown__empty {
   display: none !important;
}
</style>

<style>
.el-popper {
   z-index: 10000 !important;
}

.el-select-dropdown__item.selected {
   font-weight: 500 !important;
}
</style>
